module.exports = __webpack_public_path__ + "static/img/together-trans.d74e655.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/campaign/together-trans.png
// module id = 7anZ
// module chunks = 0